import {
  de as translationsDe,
  en as translationsEn,
} from "@zvv-fkm/translations";
import { Language } from "@zvv-fkm/types";
import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      de: {
        translation: translationsDe,
      },
      en: {
        translation: translationsEn,
      },
    },
    fallbackLng: Object.values(Language),
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
